module.exports = __webpack_public_path__ + "static/media/header_size.094080d8.jpg";